document.addEventListener('DOMContentLoaded', function (event) {

  if (jQuery('#alumni_simplepay_kartya_authorizacio').length > 0) {
    new Vue({
      el: '#alumni_simplepay_kartya_authorizacio',
      data: {
        transactionId: '',
        statusz: '',
        uzenet: ''
      },
      mounted: function () {
        const _this = this;

        setTimeout(function () {
          _this.fizetesEllenorzese();
        }, 2000);
      },

      methods: {
        urlCsere() {
          if (window.history.replaceState) {
            window.history.replaceState({}, '', 'tranzakcio_statusz');
          }
        },

        fizetesEllenorzese: function () {
          const _this = this;

          var formData = new FormData();
          formData.append('action', 'simplepay_payment_check');
          formData.append('t', t);
          formData.append('o', o);

          axios.post('/wp-admin/admin-ajax.php', formData)
            .then(function (response) {
              _this.transactionId = response.data.transactionId;

              if (response.data.status == 'EXCEPTION_ERROR') {
                _this.statusz = response.data.status;
                _this.uzenet = response.data.msg;
                _this.urlCsere();

              } else if (['TRANSACTION_NOT_FOUND', 'INFRAUD'].indexOf(response.data.status) > -1) {
                setTimeout(function () {
                  _this.fizetesEllenorzese();
                }, 10000);

              } else {
                _this.statusz = response.data.status;
                _this.urlCsere();
              }
            })
            .catch(function (error) {

            });
        },
      },
    });
  }

  if (jQuery('#alumni_form').length > 0) {
    new Vue({
      el: '#alumni_form',
      data: {
        form: {
          adomanyozo: 1,
          nev: '',
          szuletesi_nev: '',
          szuletesi_hely: '',
          szuletesi_ido_ev: '',
          szuletesi_ido_honap: '',
          szuletesi_ido_nap: '',
          anyja_neve: '',
          email_cim: '',
          telefonszam: '',

          vegzes_szak: '',
          neptunkod: '',

          adomany_tipus: 'TER_KIALAKITAS_TAMOGATAS',
          adomany_osszege: 15000,

          szamlazas_nev: '',
          szamlazas_irszam: '',
          szamlazas_telepules: '',
          szamlazas_cim: '',
          szamlazas_adoszam: '',
          terko_nev: '',
          terko_evszam: 0,
          adatkezeles: 0,
          simplepay: 0
        },
        form_mutat: false,
        info_block_mutat: false,
        errors: null,
        terko_evszamok: [],
        evszamok: [],
        honapok: [{ "value": "1", "label": "Január" }, { "value": "2", "label": "Február" }, { "value": "3", "label": "Március" }, { "value": "4", "label": "Április" }, { "value": "5", "label": "Május" }, { "value": "6", "label": "Június" }, { "value": "7", "label": "Július" }, { "value": "8", "label": "Augusztus" }, { "value": "9", "label": "Szeptember" }, { "value": "10", "label": "Október" }, { "value": "11", "label": "November" }, { "value": "12", "label": "December" }],
        napok: [],
        veglegesites_folyamatban: false,
        adomany_tipusok: [
          {
            value: 'TER_KIALAKITAS_TAMOGATAS',
            label: 'támogatom a SZE Alumni tér kialakítását, névre szóló térkövet igénylek',
          },
          {
            value: 'ALUMNI_OSZTONDIJALAP_TAMOGATAS',
            label: 'támogatom a SZE Alumni ösztöndíj alapot, névre szóló térkövet nem igénylek',
          },
          {
            value: 'TER_KIALAKITAS_ES_ALUMNI_OSZTONDIJALAP_TAMOGATAS',
            label: 'támogatom a SZE Alumni tér kialakítását, névre szóló térkövet igénylek és adományommal támogatom a SZE Alumni ösztöndíj alapot is',
          },
        ],
      },
      computed: {
        veglegesitGombFelirat: function () {
          return this.veglegesites_folyamatban ? 'Véglegesítés folyamatban...' : 'Véglegesítés';
        }
      },
      mounted: function () {
        const _this = this;

        var p = new Promise((resolve, reject) => {
          _this.init(resolve);
        });

        Promise.all([p]).then(() => {
          setTimeout(() => {
            _this.form_mutat = true;
          }, 500)
        });
      },
      methods: {
        init: function (resolve) {
          const _this = this;

          for (var i = 1920; i < new Date().getFullYear(); i++) {
            _this.terko_evszamok.push(i);
          }

          this.form.terko_evszam = this.terko_evszamok[0];

          for (var i = 1920; i < new Date().getFullYear(); i++) {
            _this.evszamok.push(i);
          }

          this.form.szuletesi_ido_ev = this.evszamok[0];
          this.form.szuletesi_ido_honap = this.honapok[0].value;
          this.napokLekerdezese();

          resolve();
        },

        adomanyozoValt: function () {
          this.form.nev = '';
          this.form.szuletesi_nev = '';
          this.form.szuletesi_hely = '';
          this.form.szuletesi_ido = '';
          this.form.anyja_neve = '';
          this.form.email_cim = '';
          this.form.adomany_tipus = 'TER_KIALAKITAS_TAMOGATAS';
          this.form.adomany_osszege = 15000;
          this.form.szamlazas_nev = '';
          this.form.szamlazas_irszam = '';
          this.form.szamlazas_telepules = '';
          this.form.szamlazas_cim = '';
          this.form.terko_nev = '';
          this.form.terko_evszam = this.terko_evszamok[0];
          this.form.adatkezeles = 0;
          this.form.simplepay = 0;
        },

        terkoAdatMutat: function () {
          return ['TER_KIALAKITAS_TAMOGATAS', 'TER_KIALAKITAS_ES_ALUMNI_OSZTONDIJALAP_TAMOGATAS'].indexOf(this.form.adomany_tipus) > -1 ? true : false;
        },

        napokLekerdezese: function () {
          this.napok = [];
          var c = new Date(this.form.szuletesi_ido_ev, this.form.szuletesi_ido_honap, 0).getDate();
          for (var i = 1; i <= c; i++) {
            this.napok.push(i);
          }
          this.form.szuletesi_ido_nap = 1;
        },

        veglegesites: function () {
          const _this = this;

          this.errors = null;
          this.veglegesites_folyamatban = true;

          var formData = new FormData();
          formData.append('action', 'send_alumni_form');
          formData.append('form', JSON.stringify(this.form, function (key, value) {
            if (key == 'adomany_osszege' || key == 'terko_evszam') {
              return value.toString();
            }

            return value;
          }));

          axios.post('/wp-admin/admin-ajax.php', formData)
            .then(function (response) {
              _this.veglegesites_folyamatban = false;

              if (response.data.status == 'EXCEPTION_ERROR') {
                console.log(response.data.msg);
              }

              if (response.data.status == 'FIELD_ERROR') {
                _this.errors = response.data.errors;
              }

              if (response.data.status == 'SUCCESS') {
                // Ha simplepay-es fizetés van, akkor átirányítja a fizetőoldalra.
                if (response.data.simplepay_url != undefined) {
                  location.href = response.data.simplepay_url;
                } else {
                  _this.form_mutat = false;
                  _this.info_block_mutat = true;
                }
              }
            })
            .catch(function (error) {
              _this.veglegesites_folyamatban = false;
            });
        }
      },
    });
  }
});
